export default {
    "tc": "Tất cả",
    "cl": "Cùng loại",
    "kl": "Khác loại",
    "dd": "Đích danh",
}
